import { render, staticRenderFns } from "./TaxaEvasao.vue?vue&type=template&id=663e2c3b&scoped=true"
import script from "./TaxaEvasao.vue?vue&type=script&lang=js"
export * from "./TaxaEvasao.vue?vue&type=script&lang=js"
import style0 from "./TaxaEvasao.vue?vue&type=style&index=0&id=663e2c3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e2c3b",
  null
  
)

export default component.exports